import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../services/global.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { Globals } from '../../models/globals.model';
import { MatTableDataSource } from '@angular/material/table';
import { evaluateFormula } from '../kpi-models/evaluateFormula';
import { AlertComponent } from '../../common/alert/alert.component';
import { KPIFormulaBuilderService } from 'src/app/services/kpi-formula-builder.service';

@Component({
  selector: 'app-evaluate-formula-model',
  templateUrl: './evaluate-formula-model.component.html',
  styleUrls: ['./evaluate-formula-model.component.scss']
})
export class EvaluateFormulaModelComponent implements OnInit {
  isLoader: boolean;
  minDt = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
  maxDt = new Date(new Date().getTime() + (3 * 365 * 24 * 60 * 60 * 1000));
  toMinDt = new Date();
  toMaxDt = new Date(new Date().getTime() + (3 * 365 * 24 * 60 * 60 * 1000));
  formulaDataSource: MatTableDataSource<evaluateFormula>;
  mainFormulaName = this.data.formulaName;
  mainFormulaFrequency = this.data.formulaFrequency;
  mainFormulaExpression = this.data.formulaExpression;
  mainFormulaIgnoreSi = this.data.ignoreSi;
  displayedColumns: string[] = ['ConstantTag', 'ValueDataSource', 'UOM', 'EntryType'];
  inputArr = [];
  apiUri: string;
  evaluateClicked = false;
  isTypeOIAdded = false;
  formulaBuilderForm = new UntypedFormGroup({
    startTime: new UntypedFormControl({ value: new Date(new Date().setHours(0, 0, 0, 0)), disabled: false }, Validators.required),
    endTime: new UntypedFormControl({ value: new Date(new Date(new Date().setHours(0, 0, 0, 0)).getTime() + (this.data.formulaFrequency * 60 * 1000)), disabled: true }, Validators.required)
  });

  constructor(
    public dialogRef: MatDialogRef<EvaluateFormulaModelComponent>,
    public dialog: MatDialog,
    public globals: GlobalService,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly httpService: HttpService,
    private readonly kpiFormulaService: KPIFormulaBuilderService,
    public global: Globals) {
    this.apiUri = this.global.config.foundationPlatformApi_client_resourceUri;
  }

  ngOnInit(): void {
    this.isLoader = false;
    this.loadInitialData();
  }

  loadInitialData() {
    for (let i = 0; i < this.data.data.FormulaDetails.length; i++) {
      for (let c = 0; c < this.data.data.FormulaDetails[i].constants.length; c++) {
        let uniqueArr = this.inputArr.filter(item => item.ConstantTag == this.data.data.FormulaDetails[i].constants[c].constantId);
        if (uniqueArr.length == 0) {
          this.inputArr.push({
            ConstantTag: this.data.data.FormulaDetails[i].constants[c].constantId,
            ValueDataSource: this.data.data.FormulaDetails[i].constants[c].constantValue,
            UOM: this.data.data.FormulaDetails[i].constants[c].uom,
            EntryType: "C",
            isDisabled: true
          });
        }
      }
      for (let t = 0; t < this.data.data.FormulaDetails[i].tags.length; t++) {
        let uniqueArr = this.inputArr.filter(item => item.ConstantTag == this.data.data.FormulaDetails[i].tags[t].tagId);
        if (uniqueArr.length == 0) {
          this.inputArr.push({
            ConstantTag: this.data.data.FormulaDetails[i].tags[t].tagId,
            ValueDataSource: this.data.data.FormulaDetails[i].tags[t].tagId,
            UOM: this.data.data.FormulaDetails[i].tags[t].uom,
            EntryType: "T",
            isDisabled: true
          });
        }
      }
    }    
    this.formulaDataSource = new MatTableDataSource(this.inputArr);    
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }

  enableManualEntry(el) {
    el.isDisabled = !el.isDisabled;
    if (el.isDisabled) {
      el.ValueDataSource = el.ConstantTag;
    } else {
      el.ValueDataSource = '';
    }
  }

  updateEndDate(startDate) {
    this.formulaBuilderForm.patchValue({ endTime: new Date(startDate._selected.getTime() + (this.data.formulaFrequency * 60 * 1000)) });
  }
  
filterDataBeforeEvaluateFormula(){
  for (let f = 0; f < this.inputArr.length; f++) {
    if (this.inputArr[f].ConstantTag == this.inputArr[f].ValueDataSource) {
      this.inputArr[f].ValueDataSource = null;
    }
  }
  for (let i = 0; i < this.data.data.FormulaDetails.length; i++) {
    for (let t = 0; t < this.data.data.FormulaDetails[i].tags.length; t++) {
     let tagValue = this.inputArr.find((o, v) => {
        return o.ConstantTag === this.data.data.FormulaDetails[i].tags[t].tagId;
      });
      if(tagValue){
        this.data.data.FormulaDetails[i].tags[t].tagValue = tagValue.ValueDataSource;
      }
    }
  }
}
  evaluateFormula() {
  this.filterDataBeforeEvaluateFormula();
    const formulaDtls: evaluateFormula = this.data.data.FormulaDetails;
    let stTime = new Date(this.formulaBuilderForm.get('startTime').value.toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
    let edTime = new Date(this.formulaBuilderForm.get('endTime').value.toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
    this.kpiFormulaService.getEvaluateFormula(stTime, edTime, formulaDtls).subscribe((result: any): void => {
        this.isLoader = true;
        //check valueType == 'O' (Output)
        const oResult = Array.isArray(result) ? result.filter(e => e.valueType == "O" || e.valueType == "I") : [];

        //format array as per required keys to match DataSource (removed 'Time' key)
        let partialOResult = oResult.map((
          { formulaElementName, uom, value, valueType }) => ({ formulaElementName, uom, value, valueType }));

        //change keys of objects to match DataSource keys (removed 'Time' key)
        let actualOResult = partialOResult.map(item => {
          return {
            ConstantTag: item.formulaElementName,
            ValueDataSource: item.value,
            UOM: item.uom,
            EntryType: item.valueType
          };
        });

      //add 'isDisabled' key to match DataSource keys (removed 'Time' key)
      const finalOIResult = actualOResult.map(v => ({...v, isDisabled: true}))
        
      let availableData = this.formulaDataSource.data;

      // 'availableData' is already present when pop-up is opened whereas 'finalOIResult' is new response data.
      
      // get matching object between 'finalOIResult' and 'availableData' for 'ValueDataSource: null' object
      // and save it in tempResult
      let tempResult = [];
      for (let i = 0; i < finalOIResult.length; i++) {
        for (let j = 0; j < availableData.length; j++) {
          if (finalOIResult[i].ConstantTag == availableData[j].ConstantTag) {
            tempResult.push(finalOIResult[i]);
            break;
          }
        }
      }
      
      // get matching object from 'availableData' and replace the 'ValueDataSource: null' object with 'tempResult' object
      // and update 'availableData' array
      for (let k = 0; k < availableData.length; k++) {
        for (let l = 0; l < tempResult.length; l++) {
          if (availableData[k].ConstantTag == tempResult[l].ConstantTag) {
            availableData[k].ValueDataSource = tempResult[l].ValueDataSource;
            break;
          }
        }
      }     
      
      // and finally create merged data for 'formulaDataSource'
      let ids = new Set(availableData.map(d => d.ConstantTag));
      let mergedData = [...availableData, ...finalOIResult.filter(d => !ids.has(d.ConstantTag))];
      
      this.formulaDataSource.data = mergedData;
      
      this.isTypeOIAdded = true;
      this.evaluateClicked = false;
      this.isLoader = false;

      }, (error: any): void => {
        this.dialogRef.close(true);
        this.isLoader = false;
        this.globals.showAlert(AlertComponent, { success: false, message: "Error while evaluating Formula" });
      });
  }

  updateTagValue(el, val) {
    el.ValueDataSource = val;
  }

}
